import { MenuItem } from '@material-ui/core';
import * as React from 'react';
import { useState } from 'react';
import { AddPosOrderTipDialog } from 'src/components/dialog/order/AddPosOrderTipDialog';
import { SecuredContent } from 'src/components/SecuredContent';
import { RolePermissions } from 'src/constants/RolePermission';
import { translate } from 'src/i18n/translate';
import type { OrderVm } from 'src/types/OrderVm';
import { PosPayment } from 'src/types/PosPayment';
import { isPosApp } from 'src/utils/app/isPosApp';
import { isCompletedOrder } from 'src/utils/order/isCompletedOrder';
import { isDeliveryOrder } from 'src/utils/order/isDeliveryOrder';
import { isPendingOrder } from 'src/utils/order/isPendingOrder';
import { isPaymentLinkPayment } from 'src/utils/paymentMethod/isPaymentLinkPayment';
import { useSelector } from 'src/utils/react/useSelector';

export function AddTipToPosOrderContextualMenuItem({ onChange, order }: Props): React.ReactElement | null {
    const [addTipDialogState, setAddTipDialogState] = useState({ open: false });

    const payments = useSelector((state) => state.pos.payments);
    const disabledPosPaymentActions = useSelector((state) => state.pos.disabledPosPaymentActions);
    const paying = useSelector((state) => state.pos.paying);

    const disabled = disabledPosPaymentActions || paying;
    const posPaymentIsPaymentLink = payments?.some((posPayment: PosPayment) => isPaymentLinkPayment(posPayment.paymentMethod));
    const shouldRenderAddTiButton = (isCompletedOrder(order.orderStatus) || isPendingOrder(order.orderStatus)) && isPosApp(order.app) && !isDeliveryOrder(order.orderType);

    const openAddOrderTipDialog = () => setAddTipDialogState({ open: true });
    const closeAddOrderTipDialog = () => setAddTipDialogState({ open: false });

    if (!shouldRenderAddTiButton) return null;

    return (
        <SecuredContent rolePermission={RolePermissions.ADD_TIP_ON_CLOSED_ORDERS}>
            <AddPosOrderTipDialog open={addTipDialogState.open} onClose={closeAddOrderTipDialog} onSuccess={onChange} order={order} />
            <MenuItem disabled={disabled || posPaymentIsPaymentLink} onClick={openAddOrderTipDialog}>
                {translate('Add Tip')}
            </MenuItem>
        </SecuredContent>
    );
}

type Props = {
    order: OrderVm;
    onChange?: any;
};
